import * as yup from '@if/core/yup'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const OTHER_REASON_ID = 'OTHER'
export const MAXIMUM_OTHER_COMMENT_LENGTH = 50

export type AgentWithdrawalReasonSchema = ReturnType<typeof useAgentWithdrawalReasonSchema>

export type AgentWithdrawalReasonFormValues = yup.InferSubmit<AgentWithdrawalReasonSchema>

export const useAgentWithdrawalReasonSchema = () => {
  const { t } = useTranslation()

  return useMemo(
    () =>
      yup.object({
        reasonId: yup.text().required(),
        comment: yup
          .text()
          .default('')
          .max(MAXIMUM_OTHER_COMMENT_LENGTH)
          .when('reasonId', {
            is: OTHER_REASON_ID,
            then: (commentSchema) => commentSchema.trim().required(t('agentWithdrawalReason.commentRequired')),
          }),
      }),
    [t],
  )
}
